import { Injectable } from '@angular/core';
import moment from 'moment';
import { map } from 'rxjs';
import { Ticket, TicketRecordType } from 'src/app/models/ticket/ticket.model';
import { getTicketType } from 'src/app/models/ticket/ticket.util';
import { LoadTickets, LoadTicketsFail, LoadTicketsSuccess } from '../../store';
import { SingleValueKPI } from '../types';
import { ChartType } from '../types/chart-type.types';
import { ChartService } from './chart.service';

const DAYS_LIMIT = 30;

@Injectable()
export class OldOpenCareCasesChartService extends ChartService<SingleValueKPI> {
  public readonly chart$ = this.chartsDataLoader({
    request: LoadTickets,
    failure: LoadTicketsFail,
    success: LoadTicketsSuccess,
  }).pipe(
    map(({ loading, data }) => {
      const dataValue: number =
        data?.data?.filter(
          (ticket) =>
            this.filterByStatusAndType(ticket) &&
            this.oldAgeFilter(ticket.CreatedDate),
        ).length || 0;

      return {
        ngClass: [dataValue > 0 ? 'text-orange-600' : ''],
        loading,
        data: {
          type: ChartType.SINGLE,
          id: `Open care tickets > ${DAYS_LIMIT} days`,
          title: `Open Care Tickets (Over ${DAYS_LIMIT} Days)`,
          value: dataValue,
          linkEnabled: true,
          linkParams: {
            groupBy: 'Type',
            view: 'open',
            olderThan: DAYS_LIMIT,
            type: TicketRecordType.Care,
          },
          hyperlink: '/tickets',
        } satisfies SingleValueKPI,
      };
    }),
  );

  private oldAgeFilter(inputDate: moment.MomentInput) {
    const currentDate = moment();
    const differenceInDays = currentDate.diff(inputDate, 'days');
    return differenceInDays > DAYS_LIMIT;
  }

  private filterByStatusAndType(ticket: Ticket): boolean {
    return (
      getTicketType(ticket).includes(TicketRecordType.Care) && !ticket.IsClosed
    );
  }
}
